import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import './Inicio.css';

const videos = [
  { id: 'zU4hIP9gadw', titulo: 'PLAYÓN POLIDEPORTIVO MUNICIPAL “Libertad, Igualdad e Independencia“ Clorinda' },
  { id: 'moXv8lNMc1c', titulo: 'E.P.E.P  N° 183 JIN N 45 (Laguna Naineck)' },
  { id: 'UV3e_CKh0pY', titulo: 'E.P.E.P N° 158 | Delegación Zonal (PIRANE)' }
];

const galeriaObras = {
  'PISCINA OLIMPICA CLIMATIZADA PARA DEPORTES DE ALTO RENDIMIENTO - CEF N°1 ': [
    '/img/1.jpg',
    '/img/1.2.jpg'
  ],
  'PODER LEGISLATIVO FORMOSA': [
    '/img/2.jpg',
    '/img/2.1.jpg',
    '/img/2.2.jpg'
  ],
  'REFACCION Y AMPLIACION DEL CENTRO DE DIAGNOSTICO AUTOMOTRIZ': [
    '/img/3.jpg',
    '/img/3.1.jpg',
    '/img/3.2.jpg'
  ]
};

const Inicio = () => {
  const playerRef = useRef(null);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [galeriaAbierta, setGaleriaAbierta] = useState(false);
  const [imagenesActuales, setImagenesActuales] = useState([]);
  const [indiceActual, setIndiceActual] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const loadYTAPI = () => {
      const script = document.createElement('script');
      script.src = 'https://www.youtube.com/iframe_api';
      script.async = true;
      document.body.appendChild(script);
    };

    if (!window.YT) {
      loadYTAPI();
    } else {
      createPlayer();
    }

    window.onYouTubeIframeAPIReady = () => {
      createPlayer();
    };
  }, []);

  const createPlayer = () => {
    playerRef.current = new window.YT.Player('youtube-player', {
      videoId: videos[currentVideoIndex].id,
      events: {}
    });
  };

  useEffect(() => {
    if (playerRef.current?.cueVideoById) {
      playerRef.current.cueVideoById(videos[currentVideoIndex].id);
    }
  }, [currentVideoIndex]);

  const handleGoToList = () => {
    navigate('/viewer#lista-obras');
  };

  const abrirGaleria = (titulo) => {
    const imagenes = galeriaObras[titulo];
    if (imagenes) {
      setImagenesActuales(imagenes);
      setIndiceActual(0);
      setGaleriaAbierta(true);
    }
  };

  const cerrarGaleria = () => {
    setGaleriaAbierta(false);
  };

  const siguienteImagen = () => {
    setIndiceActual((prev) => (prev + 1) % imagenesActuales.length);
  };

  const anteriorImagen = () => {
    setIndiceActual((prev) => (prev - 1 + imagenesActuales.length) % imagenesActuales.length);
  };

  return (
    <>
      <Navbar />
      <div className="inicio-wrapper">
        <div className="inicio-container fade-in">
          <h1>Bienvenido a la App de Gestión de Obras</h1>
          <p>Esta aplicación tiene como objetivo facilitar la visualización y gestión de obras,
          permitiéndote filtrar, revisar detalles y acceder a información completa de cada proyecto.</p>

          <div className="carousel-video fade-in">
            <div id="youtube-player"></div>
            <div className="carousel-indicators">
              {videos.map((_, index) => (
                <div
                  key={index}
                  className={index === currentVideoIndex ? 'active' : ''}
                  onClick={() => setCurrentVideoIndex(index)}
                ></div>
              ))}
            </div>
          </div>

          <h2 className="inauguraciones-titulo">Destacados</h2>
          <div className="inauguraciones-grid">
            {Object.entries(galeriaObras).map(([titulo, imagenes], index) => (
              <div
                className="inauguracion-item"
                key={index}
                onClick={() => abrirGaleria(titulo)}
              >
                <img src={imagenes[0]} alt={titulo} className="inauguracion-img" />
                <p className="inauguracion-texto">{titulo}</p>
              </div>
            ))}
          </div>

          <button className="go-to-list-btn" onClick={handleGoToList}>
            Ir a la Lista de Obras
          </button>
        </div>
      </div>

      {galeriaAbierta && (
        <div className="modal-galeria" onClick={cerrarGaleria}>
          <div className="modal-galeria-contenido" onClick={(e) => e.stopPropagation()}>
            <button className="cerrar-galeria" onClick={cerrarGaleria}>×</button>
            <img
              src={imagenesActuales[indiceActual]}
              alt={`Imagen ${indiceActual + 1}`}
              className="imagen-galeria"
            />
            <div className="navegacion-galeria">
              <button onClick={anteriorImagen}>&lt;</button>
              <button onClick={siguienteImagen}>&gt;</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Inicio;
